import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const visible: Ref<boolean> = ref(false)
  const toastMessage: Ref<string> = ref('')
  const toastColor: Ref<string> = ref('')
  let timeoutId: ReturnType<typeof setTimeout> | null = null

  function show(message: string, duration: number = 5000) {
    toastMessage.value = message
    visible.value = true

    // Annule un éventuel timeout précédent
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    // Programme le nouveau timeout
    timeoutId = setTimeout(() => {
      visible.value = false
      timeoutId = null
    }, duration)
  }

  function success(message: string, duration: number = 5000) {
    toastColor.value = 'success'
    show(message, duration)
  }

  function danger(message: string, duration: number = 5000) {
    toastColor.value = 'danger'
    show(message, duration)
  }

  function info(message: string, duration: number = 5000) {
    toastColor.value = 'info'
    show(message, duration)
  }

  return {
    danger,
    info,
    success,
    visible,
    toastColor,
    toastMessage,
  }
})
